<template>
  <div v-bind:class="[bgcolor, border]" class="h-navbar flex px-3">
    <div v-show="!noback" class="h-menu w-menu papsi-back-icon">
      <img v-on:click="click" v-bind:src="icon" class="block" />
    </div>
    <div
      v-if="isNormal || isLogout"
      class="flex-grow pl-1 text-lg font-bold flex justify-content items-center uppercase h-navbar"
    >
      <span v-text="title"></span>
    </div>
    <div v-else>
      <div
        v-if="show_snowman"
        v-show="!login || !menu"
        class="papsi-snowman-icon"
      >
        <img src="@/assets/icons/papsi_snowman.svg" class="block" />
      </div>
      <div v-show="login && menu" class="w-menu h-menu papsi-back-icon">
        <img
          v-on:click="openSidebar"
          src="@/assets/icons/papsi_menu_dark.svg"
          class="block"
        />
      </div>
    </div>
    <div v-show="!isNormal && !isLogout" class="flex-grow"></div>
    <div v-on:click="goProfile" v-show="(!isNormal && !isLogout) && login" class="h-menu">
      <div class="flex">
        <div
          class="text-white font-bold truncate pr-2 h-navbar flex justify-content items-center text-sm"
        >
          <span v-text="username"></span>
        </div>
        <div class="w-menu h-menu papsi-avatar-mt">
          <img src="@/assets/icons/papsi_avatar_light.svg" class="block" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixin';
export default {
  name: "v-navbar",
  mixins: [mixin],
  props: {
    type: {
      type: String,
      default: "normal",
    },
    title: {
      type: String,
      required: true,
    },
    noback: {
      type: Boolean,
      default: false,
    },
    menu: {
      type: Boolean,
      default: false,
    },
    show_snowman: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icon: "",
      login: false,
      bgcolor: "bg-white",
      username: "",
      border: "border-b",
    };
  },
  mounted() {
    this.setType(this.type);
    this.login = this.$store.state.login;
    this.username = this.$store.state.info.username;
  },
  computed: {
    isNormal() {
      return this.type.toLowerCase() == "normal";
    },
    isLogout() {
      return this.type.toLowerCase() == "logout";
    },
  },
  methods: {
    click() {
      if (this.isNormal) {
        this.$router.back();
      } else if (this.isLogout) {
        this.logout();
      } else {
        this.openSidebar();
      }
    },
    openSidebar() {
      this.$emit("opensidebar");
    },
    setType() {
      // let is_normal = type.toLowerCase() == 'normal';
      this.icon = require(this.isNormal || this.isLogout
        ? "@/assets/icons/papsi_back_dark.svg"
        : "@/assets/icons/papsi_menu.svg");
      this.bgcolor = this.isNormal || this.isLogout ? "bg-white" : "bg-primary";
      this.border = this.isNormal || this.isLogout ? "border-b" : "border-none";
    },

    goProfile() {
      this.$router.push("/profile");
    },
    logout() {
        this.$emit("logout");
    },
  },
  watch: {
    type(type) {
      this.setType(type);
    },
  },
};
</script>

<style scoped>
.papsi-back-icon {
  margin-top: 13px;
}
.papsi-snowman-icon {
  margin-top: 17px;
}
.papsi-avatar-mt {
  margin-top: 12px;
}
</style>
